import React, { useEffect } from 'react';
import Navbar2 from '../components/innerpage/Navbar2';
import Header from '../components/home_preview/Header';
import Demos from '../components/home_preview/Demos';
import DarkSection from '../components/home_preview/DarkSection';
import SaveMoney from '../components/home_preview/SaveMoney';
import Layouts from '../components/home_preview/Layouts';
import WooCommerce from '../components/home_preview/WooCommerce';
import Mobile from '../components/home_preview/Mobile';
import Features from '../components/home_preview/Features';
import DarkSection2 from '../components/home_preview/DarkSection2';
import Footer from '../components/innerpage/Footer';

function Home() {
  useEffect(() => {
    setTimeout(() => {
      if (window.initCommonScripts) window.initCommonScripts();
      if (window.initHomePreviewScripts) window.initHomePreviewScripts();
    }, 100);
  }, []);

  return (
    <>
      <div className="home-preview">
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar2 />
          <Header />
          <main>
            <Demos />
            <DarkSection />
            <SaveMoney />
            <Layouts />
            <WooCommerce />
            <Mobile />
            <Features />
            <DarkSection2 />
            <Footer />
          </main>
        </div>
      </div>
    </>
  );
}

export default Home;
